/**
 * This module has the hook, declaration types and tests for the
 * setCheckoutRuleSession mutation
 * {@label SET_CHECKOUT_RULE_SESSION}
 */
import setCheckoutRuleSession from './hook'

export * as mutation from './mutation'
export * as types from './types'
export default setCheckoutRuleSession
